var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{ref:"drawPolygonButton",staticClass:"flex items-center justify-center w-8 h-8 rounded-md bg-white-neutral !hover:bg-white-neutral !border border-gray-medium",staticStyle:{"border":"1px solid #737576"}},[_c(_setup.Icon,{staticClass:"text-xl",attrs:{"icon":"healthicons:polygon-24px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }